// ContactRow (job page round): one way to reach someone: the number or address in ink, how it's used
// under it ("Mobile · prefers texts"), and what to do with it on the right (Call, Text, Email), on a
// hairline. A customer's phones and email, a site contact, a tech's phone. Reads only --contact-*.
import { Link } from '../Link/Link.tsx';
import './ContactRow.css';

export interface ContactAction {
  label: string;
  href?: string;
  onPress?: () => void;
}

export interface ContactRowProps {
  /** "(250) 555-0173", "jordan.h@example.com". */
  value: string;
  /** How it's used: "Mobile · prefers texts". */
  note?: string;
  actions?: ContactAction[];
}

export function ContactRow({ value, note, actions = [] }: ContactRowProps) {
  return (
    <div className="fl-contact">
      <span className="fl-contact__what">
        <span className="fl-contact__value">{value}</span>
        {note ? <span className="fl-contact__note">{note}</span> : null}
      </span>
      {actions.length ? (
        <span className="fl-contact__acts">
          {actions.map((a) => (
            <Link key={a.label} href={a.href} onPress={a.onPress}>
              {a.label}
            </Link>
          ))}
        </span>
      ) : null}
    </div>
  );
}
